import { useMutation, useQueryClient } from "@tanstack/react-query";
import API from "@/api";
import { Annotation } from "@annotorious/react";

interface IObservationUpdateData {
  note?: string;
  annotations?: Annotation[];
}

function useUpdateObservation(nurseryId: string, observationId: string) {
  const queryClient = useQueryClient();
  const { mutate, isPending, error } = useMutation({
    mutationFn: async (observation: IObservationUpdateData) => {
      return API.updateRackObservation(nurseryId, observationId, observation);
    },
    onSuccess: (result) => {
      queryClient.setQueryData(["observation", nurseryId, observationId], () => {
        return result;
      });
    },
  });

  return {
    updateObservation: mutate,
    updateIsPending: isPending,
    updateError: error
  };
}

export default useUpdateObservation;
